import { addUrlProps, UrlQueryParamTypes } from 'react-url-query'

const urlPropsQueryConfig = {
  searchQuery: { type: UrlQueryParamTypes.string, queryParam: 'q' },
  disciplines: { type: UrlQueryParamTypes.array, queryParam: 'discipline' },
  experiences: { type: UrlQueryParamTypes.array, queryParam: 'experience' },
  areas: { type: UrlQueryParamTypes.array, queryParam: 'areas' },
  locationCountries: { type: UrlQueryParamTypes.array, queryParam: 'locationCountry' },
  show: { type: UrlQueryParamTypes.number }
}

export default Component => addUrlProps({ urlPropsQueryConfig })(Component)
